import React from 'react';
import './NotFound.css';

function NotFound({ onNavigateHome }) {
  return (
    <div className="not-found-container">
      <div className="not-found-card">
        <div className="not-found-glow"></div>
        <div className="not-found-illustration">
          <svg className="animated-404-svg" viewBox="0 0 100 100" width="160" height="160">
            {/* Background elements */}
            <circle cx="50" cy="50" r="45" fill="none" stroke="#e2e8f0" strokeWidth="2" strokeDasharray="5,5" />
            <circle cx="50" cy="50" r="35" fill="none" stroke="#cbd5e1" strokeWidth="1" />
            
            {/* Floating particles */}
            <circle cx="25" cy="30" r="2" fill="#0b66e3" className="floating-particle p1" />
            <circle cx="75" cy="40" r="3" fill="#38bdf8" className="floating-particle p2" />
            <circle cx="30" cy="70" r="2.5" fill="#ec4899" className="floating-particle p3" />
            <circle cx="70" cy="75" r="1.5" fill="#10b981" className="floating-particle p4" />

            {/* Glowing path */}
            <path d="M25 50 Q50 20 75 50 T125 50" fill="none" stroke="#0b66e3" strokeWidth="1.5" strokeDasharray="4 4" className="glow-path" />

            {/* Main 404 text representation */}
            <text x="50" y="58" className="svg-404-text" textAnchor="middle">404</text>
          </svg>
        </div>
        
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-message">
          We couldn't find the page you were looking for. The route is invalid or has been moved.
        </p>

        <button 
          type="button" 
          className="not-found-home-btn"
          onClick={onNavigateHome}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span>Back to Home</span>
        </button>
      </div>
    </div>
  );
}

export default NotFound;
